import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom"; // Import BrowserRouter
import App from "./components/App";
import { Provider } from "react-redux";
import store from "./store";
import { ProfileProvider } from "./ProfileContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ProfileProvider>
        <Router>
          {" "}
          {/* Wrap App with Router */}
          <App />
        </Router>
      </ProfileProvider>
    </Provider>
  </React.StrictMode>
);
